import Link from 'gatsby-link';
import styles from './sales.module.scss';
import React, { Component } from 'react';
import { css } from '@emotion/core';
import { ClipLoader } from 'react-spinners';
// import styles from './sales.module.scss';

export default class sales extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      visible: false,
      loading: false,
      disabled: false
    }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSubmit = e => {
    e.preventDefault();
    this.setState({
      loading: true,
      disabled: true
    });
    const scriptUrl = 'https://script.google.com/macros/s/AKfycbwofk7G4lcUT31GtRCz3VwWAm5OOxh__VAiy23M_nU4KwlFE7_6/exec';
    const url = `${scriptUrl}?callback=ctrlq&name=${this.state.name}&email=${this.state.email}&comments=${this.state.comments}&company=${this.state.company}`;
    console.log(url);

    fetch(url, { method: "GET", mode: 'no-cors' }).then(
      () => {
        this.setState({
          visible: true,
          loading: false
        })
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => {
      console.log(err);
    });
  }
  render() {
    const override = css`
        display: block;
        margin: 10 auto;
        border-color: green;
        border-width:thick;
    `;
    return (
      this.state.visible ?
        <div className={styles.container}>
          <div className={styles.thank_you_pop}>
            <img src="http://goactionstations.co.uk/wp-content/uploads/2017/03/Green-Round-Tick.png" />
            <h1>Thanks for reaching us!</h1>
            <p>We will be contacting you shortly. If you have any further queries, please feel free to reach us at <h4 className="cupon-pop"><span>support@getwalk.in</span></h4></p>
          </div>
        </div > :
        <div className={styles.container}>
          <div className={styles.form__panel}>
            <form onSubmit={this.handleSubmit}>
              <div className={styles.form__input__group}>
                <div className={styles.form__input__unit}>
                  <input type="text" name="name" onChange={this.handleChange} placeholder="Name" />
                </div>
              </div>
              <div className={styles.form__input__group}>
                <div className={styles.form__input__unit}>
                  <input type="text" name="email" onChange={this.handleChange} size="50" placeholder="Email" />
                </div>
              </div>
              <div className={styles.form__input__group}>
                <div className={styles.form__input__unit}>
                  <input type="text" name="company" onChange={this.handleChange} size="50" placeholder="Company" />
                </div>
              </div>
              <div className={styles.form__input__group}>
                <div className={styles.form__input__unit}>
                  <textarea type="text" name="comments" onChange={this.handleChange} size="50" rows="4" placeholder="Comments" />
                </div>
              </div>
              <button style={{ cursor: "pointer", background: "green" }} type="submit" className={styles.landing__btn}>
                <div class="spinner-border" role="status">
                  <span>Submit</span>
                  <ClipLoader
                    css={override}
                    sizeUnit={"px"}
                    size={20}
                    color={'#fffff'}
                    loading={this.state.loading}
                  />
                </div>
              </button>
            </form>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/sales.js